import { useState } from "react";

import AddDepartment from "./AddDepartment";
import Permission from "../RoleManagement/Permission";
import { Link } from "react-router-dom";


const CreateDepartment = () => {

    const [selectedRow, setSelectedRow] = useState({});
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [operation, setOperation] = useState();

    const handleAddClick = () => {
        setSelectedRow({
            department_name: "",
            description: "",
            type: "",
            status: 1,
        });
        setShowOffcanvas(!showOffcanvas);
        setOperation("create")
    };

    return (
        <>
            <Permission access={"/adddepartment"}>
                <button onClick={handleAddClick} className="btn-orange" >Add Department Master</button>
            </Permission>
            <AddDepartment
                selectedRow={selectedRow}
                setShowOffcanvas={setShowOffcanvas}
                showOffcanvas={showOffcanvas}
                setSelectedRow={setSelectedRow}
                operation={operation}
            />

        </>

    );

}

export default CreateDepartment;